module.exports = __webpack_public_path__ + "img/scroll-down@2x.ff611f85.png";